import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Crown, ArrowRight } from "lucide-react";
import Layout from "@/components/Layout";
import { http } from "@/lib/api";

export default function FoundingWall() {
  const [members, setMembers] = useState([]);
  const [count, setCount] = useState(0);

  useEffect(() => {
    http.get("/founding-wall").then(({ data }) => {
      setMembers(data.members || []);
      setCount(data.count || 0);
    }).catch(() => {});
  }, []);

  return (
    <Layout>
      <section className="bg-[#050505] pt-24 pb-16 border-b border-white/5 text-center">
        <div className="max-w-3xl mx-auto px-6">
          <Crown className="text-[#C9A055] mx-auto" size={48} strokeWidth={1.4}/>
          <div className="font-ui text-[10px] tracking-[0.32em] text-[#C9A055] mt-6">THE FOUNDING WALL</div>
          <h1 className="font-display text-4xl md:text-6xl text-[#F4F1EA] mt-4 leading-[1.05]">
            The Names<br/>Behind The Movement
          </h1>
          <p className="font-body text-[#B5B0A7] mt-6 leading-relaxed">
            These are the Truth Makers — the people who believed in Simple Truths Club from the very beginning. Their names live here, etched in gold, as long as the club does.
          </p>
        </div>
      </section>

      <section className="bg-[#050505] py-16">
        <div className="max-w-[1100px] mx-auto px-6">
          <div className="text-center mb-10">
            <div className="font-display-saira text-5xl text-[#C9A055]">{count}</div>
            <div className="font-ui text-[10px] tracking-[0.32em] text-[#8a857d] mt-2">{count === 1 ? "TRUTH MAKER" : "TRUTH MAKERS"}</div>
          </div>

          {members.length === 0 ? (
            <div className="text-center font-body italic text-[#8a857d] py-12 max-w-md mx-auto">
              The wall is waiting for its first name. Become the first Truth Maker and your first name will live here forever.
              <div className="mt-8">
                <Link to="/subscriptions" className="btn-gold inline-flex items-center gap-2">Become A Truth Maker <ArrowRight size={14}/></Link>
              </div>
            </div>
          ) : (
            <>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3" data-testid="public-founding-wall">
                {members.map((m, i) => (
                  <div key={i} className="border border-[#C9A055]/25 bg-[#0a0a0a] p-5 text-center hover:border-[#C9A055] transition-colors">
                    <div className="font-display text-xl text-[#F4F1EA]">{m.name}</div>
                    {m.joined_at && (
                      <div className="font-ui text-[9px] tracking-[0.22em] text-[#8a857d] mt-2">SINCE {new Date(m.joined_at).getFullYear()}</div>
                    )}
                  </div>
                ))}
              </div>
              <div className="text-center mt-14 border-t border-white/10 pt-10">
                <p className="font-body text-[#B5B0A7]">Want your name here?</p>
                <Link to="/subscriptions" className="btn-gold inline-flex items-center gap-2 mt-4">Join As A Truth Maker <ArrowRight size={14}/></Link>
              </div>
            </>
          )}
        </div>
      </section>
    </Layout>
  );
}
